function EventProcessorConfigurationPage() {
    /**
     *
     */
    EventProcessorConfigurationPage.prototype.initialize = function (console, eventProcessor) {
        this.id = "eventProcessorConfiguration";
        this.console = console;

        if (eventProcessor) {
            this.eventProcessorId = eventProcessor.id;
            this.eventProcessor = this.console.consoleService.filterTransient(eventProcessor);
        }
        else {
            this.eventProcessor = EventProcessor.create(this.console.node);
        }

        return this;
    };

    /**
     *
     */
    EventProcessorConfigurationPage.prototype.show = function () {
        var deferred = $.Deferred();

        this.console.nodeConfigurationScope = 3;

        this.testDate = moment().format();
        this.testTime = moment().format();

        this.elementList = [];
        this.observables = [];

        for (var m = 0; m < this.console.node.devices.length; ++m) {
            if (this.console.node.devices[m].__type.tangible) {
                var element = {
                    label: this.console.node.devices[m].label,
                    fullId: this.console.node.devices[m].id,
                    element: this.console.node.devices[m]
                };

                this.elementList.push(element);

                if (this.eventProcessor.observables.indexOf(element.fullId) >= 0) {
                    this.observables.push(element);
                }
            }


            for (var l = 0; l < this.console.node.devices[m].sensors.length; ++l) {
                var element = {
                    label: this.console.node.devices[m].label + "/" + this.console.node.devices[m].sensors[l].label,
                    fullId: this.console.node.devices[m].id + "/" + this.console.node.devices[m].sensors[l].id,
                    element: this.console.node.devices[m].sensors[l]
                };

                this.elementList.push(element);

                if (this.eventProcessor.observables.indexOf(element.fullId) >= 0) {
                    this.observables.push(element);
                }
            }
        }

        console.log("Trigger", this.eventProcessor.trigger);

        this.updateTriggers();

        deferred.resolve();

        return deferred.promise();
    };

    /**
     *
     */
    EventProcessorConfigurationPage.prototype.observablesChanged = function () {
        this.eventProcessor.observables = []

        for (var n in this.observables) {
            this.eventProcessor.observables.push(this.observables[n].fullId);
        }

        this.updateTriggers();
    };

    /**
     *
     */
    EventProcessorConfigurationPage.prototype.updateTriggers = function () {
        console.log(">>>> Update Triggers");

        this.triggers = [];

        var entry;

        if (this.eventProcessor.observables.length == 1) {
            this.triggers.push(entry =
            {
                type: "singleStateChange",
                label: "Single State Change"
            });

            // Default

            this.trigger = entry;

            this.triggers.push(entry = {
                type: "timeInterval",
                label: "State Changes over Interval of"
            });

            if (this.eventProcessor.trigger.type === "timeInterval") {
                console.log("Trigger Type is timeInterval");

                this.trigger = entry;
            }

            for (var n in this.observables[0].element.__type.events) {
                this.triggers.push(entry = {
                    type: "event",
                    label: this.observables[0].element.__type.events[n].label,
                    event: this.observables[0].element.__type.events[n].id
                });

                if (this.eventProcessor.trigger.type == "event" && entry.event == this.eventProcessor.trigger.content.event) {
                    this.trigger = entry;
                }
            }
        }
        else if (this.eventProcessor.observables.length > 1) {
            this.triggers.push(entry = this.trigger = {
                type: "singleStateChange",
                label: "Arbitrary Single State Change"
            });

            // Default

            this.trigger = entry;

            //this.triggers.push({type: "timeInterval", label: "Cumulated State Changes over Time Interval"});

            for (var m in this.observables) {
                for (var n in this.observables[m].element.__type.events) {
                    this.triggers.push(entry = {
                        type: "event",
                        label: this.observables[m].element.__type.events[n].label + " on " +
                        this.observables[m].label,
                        event: this.observables[m].element.__type.events[n].id,
                        observable: this.observables[m].fullId
                    });

                    if (this.eventProcessor.trigger.type == "event" && entry.event == this.eventProcessor.trigger.content.event) {
                        this.trigger = entry;
                    }
                }
            }
        }

        //this.triggers.push(entry =
        //{
        //    type: "userDefined",
        //    label: "User-Defined"
        //});
        //
        //if (this.eventProcessor.trigger.type == "userDefined") {
        //    this.trigger = entry;
        //}
    };

    /**
     *
     */
    EventProcessorConfigurationPage.prototype.triggerChanged = function () {
        this.eventProcessor.trigger.type = this.trigger.type;
        this.eventProcessor.trigger.content = {};

        if (this.trigger.type === "timeInterval") {
            this.eventProcessor.trigger.content.interval = 10000;
            this.eventProcessor.trigger.content.cumulation = "average";
            this.eventProcessor.trigger.content.stateVariable = this.observables[0].element.__type.state[0].id;
            this.eventProcessor.trigger.content.compareOperator = ">";
            this.eventProcessor.trigger.content.compareValue = 0;
        }
        else if (this.trigger.type === "event") {
            this.eventProcessor.trigger.content.event = this.trigger.event;
        }
    };

    /**
     *
     */
    EventProcessorConfigurationPage.prototype.createEventProcessor = function () {
        this.console.consoleService.createEventProcessor(this.console.node, this.eventProcessor).done(function (node) {
            this.console.bindNode(node);
            this.console.popPage();
        }.bind(this)).fail(function (error) {
            console.error(error);
            this.console.openMessageDialog("Failed to add Event Processor.", "error");
        }.bind(this));
    };

    /**
     *
     */
    EventProcessorConfigurationPage.prototype.updateEventProcessor = function () {
        this.console.consoleService.updateEventProcessor(this.console.node, this.eventProcessor).done(function (node) {
            this.console.bindNode(node);
            this.console.popPage();
        }.bind(this)).fail(function (error) {
            console.error(error);
            this.console.openMessageDialog("Failed to change Event Processor.", "error");
        }.bind(this));
    };

    /**
     *
     */
    EventProcessorConfigurationPage.prototype.leave = function () {
    };
}
